module.exports = __webpack_public_path__ + "img/modulo_Gallery.a4b4abb.svg";